
import React, {FC} from 'react';
import classNames from 'classnames';
import {BarsSpinner} from 'components/BarsSpinner';

import * as styles from './styles.module.scss';

type SpinnerProps = {
	children?: React.ReactNode
	className?: string
	iframe?: boolean
}

export const ReportSpinner: FC<SpinnerProps> = ({
	children,
	className,
	iframe,
}) => {
	if (!children) {
		children = (
			<>
				<h1>We're pulling up your report</h1>
				<p>This will only take a few moments...</p>
			</>
		);
	}

	return (
		<BarsSpinner className={classNames({
			[styles.shared]: true,
			[styles.spinner]: true,
			[styles.iframe]: iframe,
			[className || '']: !!className,
		})}>
			{children}
		</BarsSpinner>
	);
};
